module.exports = __webpack_public_path__ + "assets/e3b41474028df2c3c5a86205a32eb91f.png";